/* tslint:disable:indent */
import { environment } from '../../../../environments/environment';
import { DatePipe } from '@angular/common';

export class LogService {

  private className;
  private datePipe: DatePipe = new DatePipe('en-US');

  constructor(classParam) {
    this.className = classParam.name;
  }

  forClass(className) {
    this.className = className;
  }


    getPrefix() {
    return '[[' + this.datePipe.transform(new Date(), 'd/M/yy|h:mm:ss') + ' -]|[- ' + this.className + ']]-';
  }

  debug(message: string, ...optionalParams: any[]) {
    if (this.logActif() && this.debugLevel()) {
      console.log(this.getPrefix(), message, optionalParams);
    }
  }

  info(message: string, ...optionalParams: any[]) {
    if (this.logActif()) {
      console.log(this.getPrefix(), message, optionalParams);
    }
  }

  warn(message?: any, ...optionalParams: any[]) {
    if (this.logActif()) {
      console.warn(this.getPrefix(), message, optionalParams);
    }
  }

  error(message?: any, ...optionalParams: any[]) {
    if (this.logActif()) {
      console.error(this.getPrefix(), message, optionalParams);
    }
  }

    logActif() {
    return environment.activate_log === 'true';
  }

    debugLevel() {
    return environment.log_level === 'DEBUG' && environment.log_classes.includes(this.className);
  }


}
